
import {finalize} from 'rxjs/operators';
import { assign } from 'lodash';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

import { CLUser } from './user';
import { CLUserService, CLUserFilter } from './user.service';
import { NotifierService } from '../../ui';
import { CLAccount } from './account';

@Component({
  selector: 'cl-account-user-list',
  templateUrl: './account-user-list.component.html',
})
export class CLAccountUserListComponent implements OnInit {

  @Input()
  account: CLAccount

  @Input()
  deleted: boolean = false

  @Input()
  title: string = ''

  filter: CLUserFilter;

  perPage = 10
  usersCount: number = 0
  users: CLUser[]

  constructor(
    private userService: CLUserService,
    private router: Router,
    private notifier: NotifierService
  ) { }

  ngOnInit() {
    this.filter = new CLUserFilter();

    this.filter.account = this.account.id;
    this.filter.deleted = this.deleted;
    
    this.fetch();
  }

  fetchMore() {
    this.fetch(this.users.length);
  }

  private fetch(offset = 0, limit = this.perPage, replace = false) {
    this.notifier.startProgress();

    this.filter.offset = offset;
    this.filter.limit = limit;

    this.userService
      .users(this.filter).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        // Replace
        if (replace) {
          this.users = result.users;
        }
        // Append
        else {
          this.users = [...this.users || [], ...result.users];
        }

        this.usersCount = result.usersCount;
      });
  }

  showCLUser(user: CLUser, event: Event) {
    let nodeName = (<Element>event.target).nodeName;

    if (nodeName === 'TD' || nodeName === 'TR') {
      if (user.deleted) {
        this.router.navigate(['shares-ledger', 'client-users', 'deleted', user.id]);
      }
      else {
        this.router.navigate(['shares-ledger', 'client-users', user.id]);
      }
    }
  }
}
